<template>
  <div v-if="loading" class="d-flex justify-center mt-5">
    <v-progress-circular
      :size="200"
      :width="10"
      color="white"
      indeterminate
    ></v-progress-circular>
  </div>
  <v-container fluid grid-list-md v-else>
    <v-dialog v-model="showAlertToRemoveDialog" width="1000" :z-index="10000">
      <v-card>
        <v-card-title class="headline top-title">
          Lever l'alerte : {{ alertToRemove }}
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="removeAlertMotivation"
            label="Pour quelle raison lever l'alerte ?"
          ></v-textarea>
          <v-select
            :items="[
              { text: 'Un jour', value: 1 },
              { text: 'Une semaine', value: 7 },
              { text: 'Deux semaines', value: 14 }
            ]"
            v-model="removeAlertDuration"
            label="Pour combien de temps ?"
          ></v-select>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="alertToRemove = null" color="grey">Annuler</v-btn>
          <v-btn
            flat
            @click="removeAlert(alertToRemove, true)"
            color="primary"
            :disabled="
              removeAlertDuration === 0 || removeAlertMotivation === ''
            "
          >
            Valider
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <ProjectHeader
          @update="setProgress($event)"
          @displayFloatingWindows="displayFloatingWindows"
          :next-column="nextColumn"
          :next-column-allowed="nextColumnAllowed"
          :complete="complete.isComplete"
          :can-submit="complete.isComplete && docStatus.result === 'ok'"
          :edit-mode="editMode"
        />

        <v-card
          :class="{
            'main-panel-desktop': $mq !== 'xs' && $mq !== 'sm' && $mq !== 'md'
          }"
          class="mt-3"
        >
          <v-tabs v-model="leftTab" @change="tabChanged($event)" grow dark>
            <v-tab ripple>Projet</v-tab>
            <v-tab ripple>Locataire</v-tab>
            <v-tab ripple>Propositions</v-tab>
            <v-tab ripple>Visites</v-tab>
            <v-tab ripple>Documents</v-tab>
            <v-tab ripple v-if="isAdminOrSuperAdmin">Admin</v-tab>
            <v-tab-item>
              <v-alert
                type="warning"
                class="mb-1"
                :value="true"
                v-if="missingVisitAuthor"
              >
                Il y a au moins une visite pour laquelle l'auteur n'est pas
                renseigné. La facturation sera inexacte.
              </v-alert>
              <v-alert
                type="warning"
                class="mb-1"
                :value="true"
                v-if="!complete.isComplete && complete.incomplete.length"
              >
                Merci de compléter les informations en orange pour soumettre le
                dossier :
                <LimitedList :list="complete.incomplete" />
              </v-alert>
              <v-alert
                type="warning"
                class="mb-1"
                :value="true"
                v-if="docStatus.result === 'incomplete'"
              >
                Un document est manquant, la soumission sera impossible :
                <LimitedList :list="docStatus.reasons" />
              </v-alert>
              <v-alert
                type="warning"
                class="mb-1"
                :value="true"
                v-if="docStatus.result === 'incomplete-submission'"
              >
                Il manque au moins un document essentiel, la soumission sera
                impossible.
                <span>{{ docStatus.reasons[0] }}</span>
                <v-btn @click="allowNoIncome" v-if="docStatus.override">
                  {{ docStatus.override.text }}
                </v-btn>
              </v-alert>
              <v-alert
                type="info"
                class="mb-1"
                :value="true"
                v-if="
                  project.progress && project.progress.submittedToHil != null
                "
              >
                Le dossier a été soumis à Home in Love
              </v-alert>
              <v-alert
                type="warning"
                class="mb-1"
                :value="true"
                v-for="(a, idx) in project.activeAlerts"
                :key="idx"
              >
                <div
                  class="d-flex d-flex-initial align-center justify-space-between"
                >
                  <div>{{ a }}</div>
                  <div>
                    <v-btn @click="removeAlert(a)">Lever l'alerte</v-btn>
                  </div>
                </div>
              </v-alert>
              <ProjectInfos
                :project="project"
                :edit-mode="editMode"
                :fields-getter="infosFieldsGetter"
                :validators="nextValidation"
                v-if="leftTab === 0"
              />
            </v-tab-item>
            <v-tab-item>
              <ProjectTenant
                :project="project"
                :edit-mode="editMode"
                :validators="nextValidation"
                v-if="leftTab === 1"
              />
            </v-tab-item>
            <v-tab-item>
              <ProjectPropositions
                :project="project"
                :edit-mode="editMode"
                v-if="leftTab === 2"
              />
            </v-tab-item>
            <v-tab-item>
              <ProjectVisites
                :project="project"
                :edit-mode="editMode"
                v-if="leftTab === 3"
              />
            </v-tab-item>
            <v-tab-item>
              <ProjectDocuments
                :project="project"
                :edit-mode="editMode"
                v-if="leftTab === 4"
              />
            </v-tab-item>
            <v-tab-item v-if="isAdminOrSuperAdmin">
              <ProjectAdmin
                :project="project"
                :proposals="proposals"
                :edit-mode="editMode"
                v-if="leftTab === 5"
              />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
      <v-card class="floating-window">
        <ProjectStats @hideFloatingWindows="hideFloatingWindows"></ProjectStats>
        <v-tabs v-model="rightTab" grow>
          <v-tab ripple><v-icon>chat</v-icon>&nbsp;public</v-tab>
          <v-tab ripple><v-icon>chat</v-icon>&nbsp;privé</v-tab>
          <v-tab ripple><v-icon>timeline</v-icon></v-tab>
          <v-tab-item>
            <Comments
              v-if="rightTab === 0"
              :target-id="project._id"
              :edit-mode="editMode"
              :filter="({ visibility }) => visibility === 'all'"
              :extra-attributes="{ visibility: 'all' }"
            ></Comments>
          </v-tab-item>
          <v-tab-item>
            <Comments
              v-if="rightTab === 1"
              :target-id="project._id"
              :edit-mode="editMode"
              :filter="({ visibility }) => visibility !== 'all'"
              :extra-attributes="{ visibility: 'sales' }"
            ></Comments>
          </v-tab-item>
          <v-tab-item>
            <Timeline
              v-if="rightTab === 2"
              :edit-mode="editMode"
              :target-id="project._id"
              :link-getter="linkGetter"
              :title-getter="titleGetter"
              :description-getter="descriptionGetter"
            ></Timeline>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-layout>

    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
    <v-snackbar v-model="showSent" :timeout="7000"
      >Etat du dossier mis à jour</v-snackbar
    >
  </v-container>
</template>
<script>
import LimitedList from "@/components/LimitedList";
import { cloneDeep, flattenDepth } from "lodash";
import moment from "moment";
import { mapActions, mapGetters, mapState } from "vuex";
import { PROGRESS_ORDER } from "../../../webapp-commons/data";
import Comments from "../components/comments/Comments.vue";
import ProjectAdmin from "../components/project/ProjectAdmin.vue";
import ProjectDocuments from "../components/project/ProjectDocuments.vue";
import ProjectHeader from "../components/project/ProjectHeader";
import ProjectInfos from "../components/project/ProjectInfos.vue";
import ProjectPropositions from "../components/project/ProjectPropositions.vue";
import ProjectTenant from "../components/project/ProjectTenant.vue";
import ProjectVisites from "../components/project/ProjectVisites.vue";
import ProjectStats from "../components/ProjectStats";
import Timeline from "../components/timeline/Timeline";
import {
  PROJECT_DOCS_LEASE_VALIDATION,
  PROJECT_LEASE_FETCHED_VALIDATION,
  PROJECT_TO_ASSIGN_VALIDATION,
  PROJECT_VALIDATION
} from "@/data/DefaultSettings";
import {
  getInfoFields,
  getTenantFields,
  getTimelineDescriptions,
  getTimelineLinks,
  getTimelineTitles
} from "@/data/leaseData";
import { checkFormLine } from "@/utils";

const propertyToFieldName = (function() {
  const infoFields = getInfoFields();
  const tenantFields = getTenantFields();

  const flattenedFields = flattenDepth(
    [Object.values(infoFields), Object.values(tenantFields)],
    2
  );
  return Object.assign(
    // Fields declared unusually (directly in vue templates)
    {
      futurNeighborhoodAdmin: "Décrivez votre futur quartier",
      descEstateAdmin: "Bien idéal",
      customerSituation: "Situation du client (privé)",
      aboutYouAdmin: "A propos du client",
      chosenEstate: "Sélection du bien final"
    },
    ...flattenedFields.map(({ name, label }) => ({ [name]: label }))
  );
})();

export default {
  components: {
    LimitedList,
    ProjectStats,
    ProjectHeader,
    ProjectInfos,
    ProjectTenant,
    ProjectPropositions,
    ProjectVisites,
    ProjectDocuments,
    ProjectAdmin,
    Timeline,
    Comments
  },
  timers: {
    sync: { time: 3000, autostart: true, repeat: true }
  },
  data() {
    return {
      leftTab: 0,
      rightTab: 0,
      showError: false,
      origProject: null,
      loading: true,
      showSent: false,
      showRightOnMobile: false,
      alertToRemove: null,
      removeAlertMotivation: "",
      removeAlertDuration: 0,
      showAlertToRemoveDialog: false
    };
  },

  async mounted() {
    await this.fetchProject({ id: this.$route.params.id });

    if (!this.project) {
      this.$router.push("/reloc");
      return;
    }

    this.origProject = cloneDeep(this.project);
    this.loading = false;
    if (this.$route.params.tab != null) {
      switch (this.$route.params.tab) {
        case "tenant":
          this.leftTab = 1;
          break;
        case "proposals":
          this.leftTab = 2;
          break;
        case "visits":
          this.leftTab = 3;
          break;
        case "documents":
          this.leftTab = 4;
          break;
        case "admin":
          this.leftTab = 5;
          break;
      }
    }
    window.addEventListener("beforeunload", this.sync);
    window.addEventListener("unload", this.sync);
  },

  beforeDestroy() {
    this.sync();
    window.removeEventListener("beforeunload", this.sync);
    window.removeEventListener("unload", this.sync);
  },

  methods: {
    ...mapActions("projects", ["fetchProject", "syncProject"]),
    ...mapActions("comments", ["fetchComments", "pushComment"]),

    removeAlert(a, confirm = false) {
      if (!confirm) {
        this.showAlertToRemoveDialog = true;
        this.alertToRemove = a;
        this.removeAlertMotivation = "";
        this.removeAlertDuration = 0;
      } else {
        this.project.alertsSkipped = this.project.alertsSkipped || {};
        this.project.alertsSkipped[this.alertToRemove] = moment()
          .add(this.removeAlertDuration, "days")
          .toDate();
        this.showAlertToRemoveDialog = false;
        this.pushComment({
          content: `Alerte "${this.alertToRemove}" levée pour ${this.removeAlertDuration} jour(s) car "${this.removeAlertMotivation}"`,
          targetId: this.project._id,
          extraAttributes: {
            visibility: "sales"
          }
        });
      }
    },

    allowNoIncome() {
      this.project.overrides = this.project.overrides || {};
      this.project.overrides.income = {
        trigram: this.trigram,
        date: new Date()
      };
    },

    displayFloatingWindows() {
      window.document.body.classList.add("display-floating-window");
    },

    hideFloatingWindows() {
      window.document.body.classList.remove("display-floating-window");
    },

    setProgress(column) {
      this.project.currentProgress = column;
      this.showSent = true;
      this.$forceUpdate();
    },

    async sync() {
      console.log("sync !");
      if (this.loading) {
        return;
      }
      try {
        await this.syncProject();
      } catch (e) {
        console.error(e);
        this.showError = true;
      }
    },

    tabChanged(tab) {
      const pid = this.$route.params.id;
      switch (tab) {
        case 1:
          this.$router.replace(`/project/${pid}/tenant`);
          break;
        case 2:
          this.$router.replace(`/project/${pid}/proposals`);
          break;
        case 3:
          this.$router.replace(`/project/${pid}/visits`);
          break;
        case 4:
          this.$router.replace(`/project/${pid}/documents`);
          break;
        case 5:
          this.$router.replace(`/project/${pid}/admin`);
          break;
        default:
          this.$router.replace(`/project/${pid}`);
          break;
      }
    }
  },
  computed: {
    ...mapState("projects", {
      project: state => state.current,
      proposals: state => state.proposals,
      proposalsLoaded: state => state.proposalsLoaded
    }),
    ...mapGetters("user", ["isAdminOrSuperAdmin"]),
    ...mapState("user", ["trigram"]),
    ...mapGetters("projects", [
      "docStatus",
      "docStatusForDispatch",
      "proposalsWithVisits"
    ]),

    editMode() {
      // Only allow edit mode for projects in the compta tab to admins or superadmins
      if (
        PROGRESS_ORDER.indexOf(this.project.currentProgress) >=
        PROGRESS_ORDER.indexOf("sentToAL")
      ) {
        return this.isAdminOrSuperAdmin;
      }

      return true;
    },

    missingVisitAuthor() {
      if (!this.proposalsLoaded) {
        return false;
      }
      let error = false;
      for (const prop of this.proposals) {
        if (prop.disabled || !prop.visited || prop.visited.dateVisite == null) {
          continue;
        }
        if (!prop.visited.author) {
          error = true;
        } else if (
          prop.visited.author === "other" &&
          (prop.visited.authorOther === "" || prop.visited.authorOther == null)
        ) {
          error = true;
        }
      }
      return error;
    },

    activeAlerts() {
      return this.project.alerts.filter(a => {
        return (
          this.project.alertsSkipped[a] &&
          moment(this.project.alertsSkipped[a]).isBefore()
        );
      });
    },
    titleGetter() {
      return getTimelineTitles;
    },

    linkGetter() {
      return getTimelineLinks;
    },

    descriptionGetter() {
      return getTimelineDescriptions;
    },

    infosFieldsGetter() {
      return getInfoFields;
    },

    nextColumn() {
      const idx = PROGRESS_ORDER.indexOf(this.project.currentProgress);
      if (idx === -1 || idx + 1 > PROGRESS_ORDER.length) {
        return null;
      } else {
        return PROGRESS_ORDER[idx + 1];
      }
    },

    nextColumnAllowed() {
      const allowed = [
        "projectCreated",
        "toCall",
        "eligibility",
        "docsMobiPass",
        "toAssign",
        "leaseFetched",
        "signed"
      ];
      return allowed.indexOf(this.project.currentProgress) !== -1;
    },

    nextValidation() {
      const toAssignIdx = PROGRESS_ORDER.indexOf("toAssign");
      const docsLeaseIdx = PROGRESS_ORDER.indexOf("docsLease");
      const leaseFetchedIdx = PROGRESS_ORDER.indexOf("leaseFetched");
      const nextColumnIdx = PROGRESS_ORDER.indexOf(this.nextColumn);

      switch (true) {
        case nextColumnIdx <= toAssignIdx:
          return PROJECT_TO_ASSIGN_VALIDATION;
        case nextColumnIdx <= docsLeaseIdx:
          return PROJECT_DOCS_LEASE_VALIDATION;
        case nextColumnIdx <= leaseFetchedIdx:
          return PROJECT_LEASE_FETCHED_VALIDATION;
        default:
          return PROJECT_VALIDATION;
      }
    },

    complete() {
      const validation = this.nextValidation;
      const invalid = Object.keys(validation).filter(
        k => !checkFormLine(validation[k], this.project[k], this.project)
      );
      const incompleteMessages = invalid.map(k => propertyToFieldName[k]);
      let insufficientVisits = false;
      if (this.nextColumn === "awaitingSignature") {
        const hasFinalHost = Boolean(this.project.chosenEstate);
        const hasFinalHostWithAddress =
          hasFinalHost &&
          this.proposals.some(
            p => p.idSell === this.project.chosenEstate && p._host.addressObject
          );
        const hasEnoughVisits =
          this.proposalsWithVisits.filter(p => p._host.addressObject).length >=
          3;
        const hasEnoughProposalsWithAddress =
          this.proposals.filter(p => p._host.addressObject).length >= 3;

        insufficientVisits =
          !hasFinalHost ||
          !hasFinalHostWithAddress ||
          !(hasEnoughVisits || hasEnoughProposalsWithAddress);
        if (insufficientVisits) {
          incompleteMessages.push(
            "Un bien doit avoir été retenu et au moins 3 biens doivent avoir été visités"
          );
        }
      }
      return {
        isComplete:
          invalid.length === 0 &&
          this.docStatusForDispatch === "ok" &&
          !insufficientVisits,
        incomplete: incompleteMessages
      };
    }
  },
  beforeRouteUpdate(to, from, next) {
    next();
  },
  watch: {
    $route() {
      this.sync();
    }
  }
};
</script>
<style scoped>
.v-tabs .v-window__container {
  height: auto !important;
}

.main-panel-desktop {
  margin-right: 410px;
}
</style>
<style>
.floating-window {
  z-index: 200;
  position: fixed;
  width: 400px;
  right: 20px;
}

@media screen and (max-width: 939px) {
  .floating-window {
    width: calc(100vw - 20px);
    right: 10px;
    left: 10px;
  }
}

@media screen and (max-width: 939px) {
  .floating-window,
  .floating-window-2 {
    display: none;
  }

  .display-floating-window .floating-window,
  .display-floating-window .floating-window-2 {
    display: block;
  }
}
</style>
